import {AbstractControl, UntypedFormBuilder} from '@angular/forms';
import {Injector} from '@angular/core';
import {FieldConfig} from './field.config';

export type ControlBuilder = (
    fieldConfig: FieldConfig<any>,
    fb: UntypedFormBuilder,
    injector?: Injector,
) => AbstractControl;
